export default __webpack_public_path__ + "static/media/dong-gia-1k-ve-khi-mua-ve-qua-tix-16043766276410.5f0e818c.jpg";